import styled from 'styled-components';

import { CrossMIcon } from 'assets/icons';
import { DaDataUiKit as BaseDaDataUiKit } from 'components/primitives/dadata-uikit/DaDataUiKit';
import { AttentionCard as BaseAttentionCard } from 'components/uikit/AttentionCard/AttentionCard';
import {
  CloseCross,
  RowCloseCrossWrapper,
} from 'components/uikit/AttentionCard/AttentionCard.styles';
import { Checkbox as BaseCheckbox } from 'components/uikit/Form/Checkbox/Checkbox';
import { Radio as BaseRadio } from 'components/uikit/Form/Radio/Radio';
import { RadioGroup as BaseRadioGroup } from 'components/uikit/Form/RadioGroup/RadioGroup';
import { Searcher as BaseSearcher } from 'components/uikit/Form/Searcher/Searcher';
import { Select as BaseSelect } from 'components/uikit/Form/Select/Select';
import { Switcher as BaseSwitcher } from 'components/uikit/Form/Switcher/Switcher';
import { TextInput as BaseTextInput } from 'components/uikit/Form/TextInput/TextInput';
import { TextInputMasked as BaseTextInputMasked } from 'components/uikit/Form/TextInputMasked/TextInputMasked';

import { withNamedEvent } from './hocs/withNamedEvent';
import { withNormalizedTextInputStyles } from './hocs/withNormalizedTextInputStyles';

const DEFAULT_TEXT_INPUT_PROPS = {
  ClearButton: ({ regular }) => {
    return regular ? undefined : CrossMIcon;
  },
  size: 'm',
  theme: '2',
};

export const Checkbox = styled(withNamedEvent(BaseCheckbox, { target: 'checked' })).attrs({
  size: 'xs',
  theme: '2',
})``;

export const DaDataUiKit = withNormalizedTextInputStyles(BaseDaDataUiKit, {
  size: 'm',
  theme: '2',
});

export const PageWarningCard = styled(BaseAttentionCard).attrs({
  hasCloseCross: true,
  type: 'void',
})`
  --color-bkg: var(--color-orange-4);
  --color-close-icon: var(--color-grey-12_30);

  ${CloseCross} {
    --width: 16px;
    --height: 16px;
  }

  ${RowCloseCrossWrapper} {
    padding: 8px;
  }

  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const Radio = styled(withNamedEvent(BaseRadio, { target: 'value' })).attrs({
  size: 's',
  theme: '1',
})``;

export const RadioGroup = styled(withNamedEvent(BaseRadioGroup, { target: 'broadcast' }))``;

export const Searcher = withNormalizedTextInputStyles(BaseSearcher, { size: 'm', theme: '2' });

export const Select = styled(withNamedEvent(BaseSelect, { target: 'broadcast' })).attrs({
  size: 'm',
  theme: '2',
})``;

export const Switcher = styled(withNamedEvent(BaseSwitcher, { target: 'checked' })).attrs({
  size: 'm',
  theme: '1',
})``;

export const TextInput = withNormalizedTextInputStyles(BaseTextInput, DEFAULT_TEXT_INPUT_PROPS);

export const TextInputMasked = withNormalizedTextInputStyles(
  BaseTextInputMasked,
  DEFAULT_TEXT_INPUT_PROPS
);
